'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import Breadcrumb from 'Components/Front/Breadcrumb';
import bemit from 'Functions/bemit';
import DeviceIcon from 'Icons/DeviceIcon';
import PaperPlaneIcon from 'Icons/PaperPlaneIcon';
import LoginModal from 'Modals/LoginModal';
import Image from 'Pure/Image';
import Link from 'Pure/Link';
import numeral from 'numeral';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import { num } from 'Shared/utilities';
import { URL } from 'Shared/Routes';
const app = window.app;
const qwest = window.qwest;
const breadcrumb = [{
  name: 'home',
  url: URL('HomePage'),
  label: 'Accueil'
}, {
  name: 'current-page',
  label: 'Offre entreprise',
  url: URL('CompanyOfferPage')
}];
export default class CompanyOfferPage extends Component {
  state = {
    open: false,
    login_modal: false
  };
  ref_header = React.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    if (app?.state?.session?.user?.roles?.length > 0) {
      component.handleSessionChange({
        source: 'FrontHeader-DidMount'
      });
    }
    component.setState({
      open: false
    });
    component.fetchPack();
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  handleSessionChange = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      roles: app?.state?.session?.user?.roles || []
    });
  };
  openLoginModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      login_modal_trigger: e.target,
      login_modal: true
    });
  };
  closeLoginModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      login_modal_trigger: undefined,
      login_modal: false
    });
  };
  handleLogin = user => {
    const component = this,
      props = this.props,
      state = this.state;

    // Update user permissions now that user is connected
    app.emit({
      event: 'sessionNeedsRefresh',
      source: 'loginModal',
      data: {
        url: user.roles?.includes('customer') ? URL('CustomerBookingsDashboard') : user.roles?.includes('hotelier') ? URL('AdminCoworkingSpacesDashboard') : user.roles?.includes('admin') ? URL('AdminEtablishmentsDashboard') : undefined
      }
    });
  };
  fetchPack = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/pack/get-all', {
      display_status: 'true',
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        packs: (response.data || []).sort(function (pack_a, pack_b) {
          return num(pack_a.credit_amount) > num(pack_b.credit_amount) ? 1 : -1;
        }),
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  onContactClick = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    app.emit({
      event: 'TC_Click',
      source: 'CompanyOfferPage',
      data: {
        e: e,
        action: 'contact_conseiller'
      }
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let packs = (state.packs || []).map(function (pack) {
      let amount = numeral(pack.credit_amount).multiply(pack.amount).format('0.00');
      let month_duration = moment().add(pack.duration, 'days').diff(moment(), 'months');
      let output = /*#__PURE__*/React.createElement("div", {
        key: pack.id,
        className: "c-pack-list__grid-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-pack-list__grid-item-credits"
      }, pack.credit_amount, " H", /*#__PURE__*/React.createElement("span", null, "soit ", pack.credit_amount, " cr\xE9dits")), /*#__PURE__*/React.createElement("div", {
        className: "c-pack-list__grid-item-title"
      }, pack.title, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
        className: "c-pack-list__grid-item-duration"
      }, "Validit\xE9 : ", month_duration, " mois")), /*#__PURE__*/React.createElement("div", {
        className: "c-pack-list__grid-item-description"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "c-pack-list__grid-item-ul"
      }, /*#__PURE__*/React.createElement("li", null, "Acc\xE8s aux 2 types d'espace de coworking myWO :", /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Espace Lounge, calme et isol\xE9, r\xE9servable en ligne"), /*#__PURE__*/React.createElement("li", null, "Espace Lib accessible (sous r\xE9serve de places et de consommation)."))), /*#__PURE__*/React.createElement("li", null, "Welcome drink en myWO Lounge (fontaine \xE0 eau, cocktail d\xE9tox...)"))), /*#__PURE__*/React.createElement("div", {
        className: "c-pack-list__grid-item-total"
      }, "Tarif : ", /*#__PURE__*/React.createElement("span", {
        className: "c-pack-list__grid-item-price"
      }, amount, "\u20AC HT"), " ", ' ', " soit ", pack.amount, "\u20AC HT par cr\xE9dit"));
      return output;
    });
    let output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
      meta_title: "myWO - Offre entreprise",
      meta_description: "Start-up ou entreprise, payez ce dont vous avez besoin. myWO vous propose des formules sur-mesure."
    }), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['concept', 'offre-entreprise'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__bg"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__content c-front-page-intro__content--offre-entreprise"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__left"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      bemit: ['white'],
      className: "u-margin-bottom-10",
      links: breadcrumb
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-pack-list__presentation"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-pack-list__presentation-col c-pack-list__presentation-col--white"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "c-front-page-intro__title c-front-page-intro__title--offre-entreprise"
    }, "Offre entreprise"), /*#__PURE__*/React.createElement("p", {
      className: "offre-entreprise-subtitle"
    }, "Le bon choix en fonction de vos besoins"), /*#__PURE__*/React.createElement("p", null, "Start-up ou entreprise, payez ce dont vous avez besoin. ", /*#__PURE__*/React.createElement("br", null), "myWO vous propose des formules sur-mesure")), /*#__PURE__*/React.createElement("div", {
      className: "c-pack-list__presentation-col"
    }, /*#__PURE__*/React.createElement(Image, {
      src: "/images/offre_entreprise.png",
      alt: "Offre entreprise myWO",
      className: "c-pack-list__presentation-col-image"
    })))))), /*#__PURE__*/React.createElement("div", {
      className: "front-internal-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-side-item', ['concept'])
    }, /*#__PURE__*/React.createElement("h2", {
      className: "c-title c-title--pack"
    }, "Les formules"), /*#__PURE__*/React.createElement("div", {
      className: "c-pack-list__grid"
    }, packs), /*#__PURE__*/React.createElement("div", {
      className: "c-pack__info"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-pack__info-col c-pack__info-col--shadow"
    }, /*#__PURE__*/React.createElement(DeviceIcon, {
      className: "c-pack__info-col-icon"
    }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Vous souhaitez acc\xE9der \xE0 votre compte")), /*#__PURE__*/React.createElement("p", null, "Retrouvez un service personnalis\xE9 pour l'achat et le suivi de vos cr\xE9dits"), /*#__PURE__*/React.createElement("div", {
      className: "c-pack__info-col-actions"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['front', 'blue', 'spaces-types-block']),
      href: URL('CompanyCreateAccount'),
      component: Link
    }, "Cr\xE9er mon compte entreprise"), /*#__PURE__*/React.createElement("span", {
      className: "c-pack__info-col-actions-separator"
    }, "ou"), /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['front', 'white-blue', 'spaces-types-block']) + " u-margin-left-10",
      onClick: component.openLoginModal,
      component: Link
    }, "Se connecter au compte entreprise"))), /*#__PURE__*/React.createElement("div", {
      className: "c-pack__info-col"
    }, /*#__PURE__*/React.createElement(PaperPlaneIcon, {
      className: "c-pack__info-col-icon"
    }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Vous souhaitez en savoir plus ?")), /*#__PURE__*/React.createElement("p", null, "Un expert myWO est disponible pour r\xE9pondre \xE0 toutes vos questions"), /*#__PURE__*/React.createElement("a", {
      className: bemit('c-flat-btn', ['front', 'blue', 'spaces-types-block']),
      onClick: component.onContactClick,
      href: "mailto:commercial@mywo.fr"
    }, "Contacter un conseiller"))))), /*#__PURE__*/React.createElement(LoginModal, {
      onClose: component.closeLoginModal,
      open: state.login_modal,
      trigger_src: state.login_modal_trigger,
      onLogin: component.handleLogin
    }));
    return output;
  }
}
